import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage';

export interface FirebaseUploadProgressEvent {
  progress: number;
  downloadURL?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {

  private storage = getStorage();

  constructor() { }

  uploadFile(file: File, path: string): Observable<string> {
    return this.uploadFileWithProgress(file, path).pipe(
      filter((event): event is FirebaseUploadProgressEvent & { downloadURL: string } => !!event.downloadURL),
      map(event => event.downloadURL)
    );
  }

  uploadFileWithProgress(file: File, path: string): Observable<FirebaseUploadProgressEvent> {
    return new Observable(observer => {
      const storageRef = ref(this.storage, path);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = snapshot.totalBytes
            ? Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
            : 0;
          observer.next({ progress });
        },
        (error) => {
          // Handle unsuccessful uploads
          observer.error(error);
        },
        () => {
          // Handle successful uploads on complete
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            observer.next({ progress: 100, downloadURL });
            observer.complete();
          });
        }
      );
    });
  }
}
